import { memo } from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";


export const FilterDropDown = memo((props) => {
  console.log(`from dropdown - ${props.dd_name} ${props.dd_options}`)
  const label_bgColor = (props.dd_options?.length === 0)  ?'bg-gray-400':'bg-white'
    
  const OptionStyles = {
    option: (provided, state) => ({
      ...provided,
      fontWeight: state.isSelected ? "bold" : "normal",
      color: "#0d47a1",
      backgroundColor: state.isFocused ? "#e3f2fd" : "white", // Highlight on hover,
      fontSize: "13px",
      maxHeight: 40,
      minHeight: 32,
      borderBottom: "1px dotted gray",
      textAlign: "left",
      alignItems: "center",
      display: "flex",
      padding: "6px 12px",// More padding for better spacing
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: "4px 10px",
      alignItems: "center",
      maxHeight: 44,
      minHeight: 36,
      fontSize: "14px", // Match input font size
    }),
    control: (provided, state) => ({
      ...provided,
      fontWeight: "bold",
      color: state.isDisabled ? "gray" : "#0d47a1",
      fontSize: "14px",
      backgroundColor: state.isDisabled ? "#f5f5f5" : "white",
      border: state.isFocused ? "2px solid #0d47a1" : "1px solid gray",
      alignItems: "center",
      textAlign: "left",
      display: "flex",
      maxHeight: 44,
      minHeight: 36,
      padding: "4px 10px",
      boxShadow: "none", // Removes the default blue outline
      outline: "none",   // Prevents additional focus styles
      //position: "relative",
      //flexDirection: "row-reverse",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "6px",
      svg: {
        height: "18px",
        width: "18px",
      },
    }),
    clearIndicator: (provided) => ({
      ...provided,
      height: "24px",
      padding: "2px",
    }),
    indicatorContainer: (provided) => ({
      ...provided,
      height: "20px",
      minHeight: "20px",
      padding: "0px",
      margin: "0px",
    }),
    menu: (provided) => ({
      ...provided,
      //position: "relative",
      borderBottom: "1px",
      margin: "4px 0",
      padding: "4px 0",
      backgroundColor: "white",
      borderRadius: "4px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
    }),
  }
  const labelStyle = {
      position: "absolute",
      padding: "0px 10px",
      margin: 5,
      top: "-12px", // Adjust this value as needed
      left: "5px",
      zIndex: 10,
      fontSize:9,
      color:  "#0d47a1"
  };
  const selectLabel = () => {
    let fName = props.dd_name
    let selectWord = fName.charAt(0).toUpperCase() + 
                    fName.slice(1, (fName.endsWith('s') ? fName.length - 1 : fName.length))
    console.log(selectWord);
    if (selectWord === 'Academicyear') {selectWord = 'Academic Year'}
    
    return selectWord
  }

  return (
    <div>
      {props.dd_options?.length > 0 && (
        <Controller
          control={props.control}
          name={props.dd_name}
          render={({ field }) => (
            <div className={`${label_bgColor} m-0 p-2 `}>
              <label className="text-primary-500 font-bold text-sm">{selectLabel()}</label>
              <Select
                {...field}
                className="min-w-44 font-normal text-sm px-1 m-0 focus:ring-0 active:ring-0"
                isSearchable={false}
                options={props.dd_options}
                isDisabled={props.dd_options?.length === 0}
                placeholder="Select..."
                styles={OptionStyles}
                value={props.dd_options.find((option) => option.value === field.value)}
                onChange={(selectedOption) => {
                  console.log(selectedOption.value)
                  field.onChange(selectedOption.value); // Ensuring only the value is passed
                }}
              />
            </div>
          )}
        />
      )}
    </div>
  );
});
